import React from "react";

const SwiggyLogo = () => {
    return (
        <svg width="149" height="184" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity=".2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M174.822 53.267c1.251-6.418-.182-11.353-3.876-13.93-5.558-3.875-13.905-5.983-33.787-5.983-14.71 0-30.503.015-37.251.012-.627-.111-2.893-.779-2.979-3.255l-.092-39.303c-.002-2.48 2.189-4.498 4.898-4.504 2.713-.004 4.914 2.007 4.916 4.486 0 0 .068 21.336.074 28.918 0 .732.468 2.442 2.289 2.887 11.876 2.897 71.908.779 70.975-9.19C174.895-27.945 136.683-60 90.288-60c-14.61 0-28.442 3.182-40.691 8.826C20.284-37.38-.534-9.536.01 22.625c.387 22.794 16.805 63.31 26.856 69.324 4.632 2.774 10.733 1.747 38.013 1.747 12.37 0 23.89.037 29.552.06.588.102 3.674.749 3.674 3.345l.072 29.876c.007 2.482-2.187 4.499-4.9 4.5-2.708.004-4.908-2.004-4.913-4.484 0 0 .242-11.989.242-16.46 0-1.035.082-2.812-3.218-4.156-10.866-4.424-46.152-1.754-48.132 3.128-.758 1.878 3.187 9.137 9.26 18.445 20.234 29.212 40.099 51.988 43.31 55.632a9.2 9.2 0 0 0 .56.418c2.65-2.949 73.288-73.657 84.436-130.733Z"
                fill="url(#a)"
            />
            <defs>
                <linearGradient
                    id="a"
                    x1="89.923"
                    y1="-60"
                    x2="114.855"
                    y2="181.581"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#449D8E" stopOpacity="0" />
                    <stop offset="1" stopColor="#449D8E" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default SwiggyLogo;
